import { useEffect } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import icon1 from "../../../asset/image/new/pharma_icon5.svg";
import icon2 from "../../../asset/image/new/allergy-2.svg";
import TestingSteps from "../../../asset/image/new/hla-b-58-group.png";

function ADRs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลที่เกี่ยวข้อง", url: "/information" },
    { name: "เภสัชพันธุศาสตร์", url: "/information/pharmacogeneticTest" },
    {
      name: "อาการไม่พึงประสงค์หลังจากการใช้ยา",
      url: "/information/pharmacogeneticTest/ADRs",
    },
  ];

  const ADRs = [
    {
      url: `${icon1}`,
      name: "อาการไม่พึงประสงค์หลังจากการใช้ยา",
      title: "ผื่นแพ้ยาแบบรุนแรง",
      symptom: null,
    },
    {
      url: `${icon2}`,
      name: "Stevens Johnson Syndrome (SJS)",
      title:
        "ความผิดปกติของผิวหนังและเยื่อเมือกบุผิวชนิดรุนแรง ที่พบได้ไม่บ่อย โดยอาจเกิดจากการติดเชื้อหรือการตอบสนองของร่างกาย ต่อยาบางชนิดในระยะแรกผู้ป่วย มักมีอาการคล้ายไข้หวัดใหญ่ ตามมาด้วยผื่นแดงที่ทำให้ รู้สึกเจ็บปวด จากนั้นผื่นจะค่อยๆ ลุกลามและกลายเป็นแผลพุพองในที่สุด",
      symptom: {
        detail: `เกิดผื่นแพ้ที่ผิวหนัง คือ ผิวหนังตายและลอกทั้งตัว นอกจากนั้นยังเกิดผื่นแพ้ยาที่เยื่อบุทั่วร่างกาย เช่น ในปาก หลอดอาหาร ลำคอ หลอดลม กล่องเสียง ช่องคลอด รูปัสสาวะ และทวารหนัก<br>
          - ระยะเวลาที่เริ่มเกิดอาการ: 1-3 สัปดาห์<br>
          - อัตราการเสียชีวิต : ร้อยละ 10<br>
          - ยาที่เป็นสาเหตุที่พบได้บ่อย: antibacterial sulfonamides, ยากันชัก กลุ่มอะโรมาติก, NSAIDs กลุ่ม oxicam, allopurinol, nevirapine และ lamotrigine`,
        image: `${TestingSteps}`,
      },
    },
    {
      url: `${icon2}`,
      name: "Toxic Epidermal Necrolysis (TEN)",
      title:
        "เป็นโรคผิวหนังในกลุ่มผื่นแพ้ยาที่พบได้น้อยโรคหนึ่งซึ่งอาจเป็นอันตรายถึงชีวิต ส่วนใหญ่เกิดเป็นปฏิกิริยาต่อยา มีลักษณะคือทำให้ ผิวหนังชั้นหนังกำพร้า (epidermis) แยกออกจากชั้นหนังแท้ (dermis) ทั่วร่างกาย",
      symptom: {
        detail: `1. ตุ่มพุพองที่ผิวหนัง อาจดูคล้ายแผลพุพอง หรือ แผลไฟไหม้น้ำร้อนลวก หรือแผลถูกสารเคมี<br>
          2. ผื่นที่เยื่อบุตา อาจดูคล้ายอาการเยื่อบุตาอักเสบ<br>
          3. ผื่นในปาก อาจดูคล้ายแผลร้อนใน (แผลแอฟทัส) แผลเริมที่เกิดในเยื่อบุปาก<br>
          - ระยะเวลาที่เริ่มเกิดอาการ : 1 - 3 สัปดาห์<br>
          - อัตราการเสียชีวิต : ร้อยละ 30<br>
          - ยาที่เป็นสาเหตุที่พบได้บ่อย : antibacterial sulfonamides, ยากันชัก กลุ่มอะโรมาติก, NSAIDs กลุ่ม oxicam, allopurinol, nevirapine และ lamotrigine`,
        image: `${TestingSteps}`,
      },
    },
    {
      url: `${icon2}`,
      name: "Drug rash eosinophilia and systemic (DRESS)",
      title:
        "เป็นกลุ่มอาการแพ้ยาชนิดรุนแรง (drug hypersensitivity syndrome) มีอัตราการตาย 50% โดยผืนผิวหนังมีได้ หลายแบบส่วน ใหญ่จะเป็น morbilliform (maculopapular) eruption ร่วมกับมีไข้ต่อมน้ำเหลืองโต ตาเหลืองจาก ภาวะตับอักเสบ และไม่ค่อยพบ รอยโรคที่เยื่อบุ อาการเกิด กับอวัยวะภายในร่างกาย หลาย ๆ ระบบ และเกิดหลัง ได้รับยานานกว่าใน SJS/TEN คือมากกว่า 2-4 สัปดาห์ ขึ้นไป ยาที่เป็นสาเหตุของ DRESS ได้บ่อยคือ allopurinol, dapsone, sulfonamide และ Maculopapular eruption (MPE)",
      symptom: {
        detail: `1. ผื่นแดงราบหรือนูน<br>
          2. ตุ่มนํ้าหรือตุ่มหนอง<br>
          3. ผิวหนังบวมบริเวณใบหน้าหรือแขนขา<br>
          4. มีไข้สูง<br>
          5. ต่อมน้ำเหลืองโต<br>
          6. การอักเสบของอวัยวะต่าง ๆ ภายในร่างกาย<br>
          7. ภาวะตับวาย และไตวาย<br>
          ระยะเวลาที่เริ่มเกิดอาการ : 2 - 6 สัปดาห์<br>
          อัตราการเสียชีวิต ร้อยละ 10 จากภาวะตับวาย<br>
          ยาที่เป็นสาเหตุที่พบได้บ่อย : ยากลุ่ม sulfonamide, ยากันชัก กลุ่มอะโรมาติก, allopurinol, gold salt, minocycline, dapson`,
        image: `${TestingSteps}`,
      },
    },
    {
      url: `${icon2}`,
      name: `ผื่นแพ้ยาแบบรุนแรง<br>
        Maculopapular eruption (MPE)`,
      title:
        "เป็นผื่นแดงแบนราบ (macule) และผื่นนูน (papule) เล็กน้อยกระจายทั่วร่างกาย มัก Spare ใบหน้า ฝ่ามือ ฝ่าเท้า ผื่นมักเกิดเร็ว ตั้งแต่ 2-3 วันหลังได้รับยาชนิดเดิม มีอาการคันร่วมด้วย เกือบทุกรายมีไข้ได้ ยาเกือบทุกชนิด ทำให้เกิดผื่นแพ้ยาชนิดนี้ได้ โดยยาที่ เป็นสาเหตุที่พบบ่อย ได้แก่ ยาปฏิชีวนะ โดยเฉพาะกลุ่มเพนิซิลลิน ยากันชัก ยารักษาโรคเกาต์ (allopurinol) และยาแก้ปวดข้อ ปวด กระดูก กลุ่ม NSAIDs เป็นต้น",
      symptom: {
        detail: `ผื่นแดงแบนราบ และผื่นนูนเล็กน้อยกระจายทั่ว ร่างกาย<br>
          2. คันเล็กน้อย<br>
          3. มีไข้ต่ำๆ<br>
          4. ไอ<br>
          5. นํ้าเหลืองโต<br>
          6. มีแผลในปาก<br>
          - ระยะเวลาที่เริ่มเกิดอาการ : 4 - 14 วัน<br>
          - อัตราการเสียชีวิต : อัตราการเสียชีวิตต่ำ<br>
          - ยาที่เป็นสาเหตุที่พบได้บ่อย : ยาเกือบทุกชนิด โดยเฉพาะยาปฏิชีวนะ, ยากันชัก, allopurinol`,
        image: `${TestingSteps}`,
      },
    },
    {
      url: `${icon2}`,
      name: `ความเสี่ยงสูงที่จะเกิดภาวะภูมิคุ้มกันไวเกิน<br>
        Abacavir hypersensitivity reaction`,
      title:
        "ผู้ป่วยอาจมีอาการไข้สูง มีผื่นขึ้นกระจายทั่วร่างกาย ลักษณะเป็นปั้นแดงร่วมกับตุ่มแดงเม็ดเล็ก ๆ คล้ายผด อาจคัน อ่อนเพลีย คลื่น ไส้ อาเจียน ท้องเสีย ปวดท้อง ปวดข้อ เจ็บคอ ไอ หายใจหอบเหนื่อย ระดับเอ็นไซม์ transaminase สูงขึ้น ซึ่งอาจส่งผลให้ผู้ป่วย บางราย ถึงแก่ชีวิตได้ อาจเกิดขึ้นหลังจากการใช้ยา abacavir ไปแล้วอย่างใกล้ชิด หากมีอาการผิดปกติใด ๆ เกิดขึ้นควร หยุดยาและ กลับมาพบแพทย์เพื่อรับการประเมินการรักษา ที่เหมาะสมต่อไป",
      symptom: {
        detail: `
          ระยะเวลาที่เริ่มเกิดอาการ : 1 - 6 สัปดาห์<br>
          ยาที่เป็นสาเหตุที่พบได้บ่อย : abacavir`,
        image: `${TestingSteps}`,
      },
    },
    {
      url: `${icon2}`,
      name: "Reference",
      title: `1. Patients with drug allergy and hypersensitivity แนวทางการวินิจฉัยผู้ป่วยแพ้ยา, พญ.ทิชา ลิ้มสุวรรณ อาจารย์หน่วยภูมิ แพ้อิมมูโนวิทยา และโรคข้อ พ.บ. ว.ว. (อายุรศาสตร์ภูมิแพ้และภูมิคุ้มกันทางคลินิก)<br>
        2. Interprofessional Team Care in Pediatrics: Learn and Work Together, ภาควิชากุมารเวชศาสตร์ คณะแพทยศาสตร์ จุฬาลงกรณ์- มหาวิทยาลัย<br>
        3. การตรวจกรอง HLA-B*5701 ในผู้ติดเชื้อ HIV/ผู้ป่วยเอดส์ที่รักษาด้วยยาต้านไวรัส สูตรพื้นฐานโดยวิธี Real time PCR, ผศ.ดร. พูนทรัพย์ ผลาขจรศักดิ์ และคณะเทคนิคการแพทย์ มหาวิทยาลัยเชียงใหม่<br>
        4. อะบาคาเวียร์ (Abacavir), ภก.วิชญ์ภัทร ธรานนท์<br>
        5. ALLOPURINOL (อัลโลพูรินอล), POBPAD<br>
        6. หลักในการบริหารยา เพื่อป้องกันพิษและอาการไม่พึงประสงค์จากยาต้านมะเร็ง, รศ.ดร.ภก.สุภัสร์ สุบงกช<br>
        7. แนวทางการตรวจรักษาและป้องกันการติดเชื้อเอชไอวีประเทศไทย ปี2557, กรมควบคุมโรค<br>
        8. การตรวจทางเภสัชพันธุศาสตร์ในการป้องกันผื่นแพ้ยาแบบรุนแรง (severe cutaneous adverse reactions: SCARs),อาจารย์ ดร.ภก.นเรนทร์ฤทธิ์ กรุณา คณะเภสัชศาสตร์ มหาวิทยาลัยเชียงใหม่`,
      symptom: null,
    },
  ];

  const stripHtml = (html) => {
    return html?.replace(/<[^>]+>/g, "");
  };

  return (
    <div className="global-page">
      <Breadcrumb pathItems={pathItems} />
      <div className="2lg:grid-cols-1 grid grid-flow-dense grid-cols-1 w-full gap-7 py-8 mt-6">
        {ADRs.map((adrs, index) => (
          <div
            key={index}
            className="sm:flex-col sm:items-center flex flex-row gap-7"
          >
            <div className="xl:max-h-36 xl:min-w-36 overflow-hidden min-w-48 max-w-48 w-[15%] max-h-48 aspect-square p-5 justify-items-center align-middle bg-white rounded-lg border border-gray-400">
              <img className="object-scale-down h-full" src={adrs.url} alt={`รูปประกอบ ${stripHtml(adrs.name)}`}/>
            </div>
            <div className="flex flex-col gap-1 w-[80%]">
              <h1
                className={`${
                  index === 0
                    ? "2sm:text-xl pb-4 text-2xl font-bold"
                    : "text-lg font-bold"
                }`}
                dangerouslySetInnerHTML={{ __html: adrs.name }}
              ></h1>
              <span
                className={`${
                  index === 0 ? "sm:text-lg text-xl font-bold" : "text-base"
                }`}
                dangerouslySetInnerHTML={{ __html: adrs.title }}
              ></span>
              {adrs.symptom != null && (
                <div className="flex flex-col gap-1 py-2">
                  <h1 className="text-lg font-bold">อาการ</h1>
                  <span
                    className="text-wrap"
                    dangerouslySetInnerHTML={{ __html: adrs.symptom.detail }}
                  ></span>
                  {/* <div
                    className="relative flex text-blue-800 text-base"
                    onMouseLeave={() => setShowImage(null)}
                  >
                    <div
                      className="cursor-pointer underline"
                      onMouseEnter={() => setShowImage(index)}
                      onClick={() => setShowImage(index)}
                    >
                      ดูภาพอาการ
                    </div>
                    {index == showImage && (
                      <div className="sm:w-[100%] absolute w-[120%] rounded-lg p-7 right-0 bottom-6 bg-white shadow-md border border-gray-200">
                        <img
                          className="object-cover h-full"
                          src={adrs.symptom.image}
                          alt={`ภาพอาการ ${stripHtml(adrs.name)}`}
                        />
                      </div>
                    )}
                  </div> */}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ADRs;
